export interface ShippingAddress {
  fullName: string;
  company: string;
  streetLine1: string;
  streetLine2: string;
  city: string;
  province: string;
  postalCode: string;
  countryCode: string;
  phoneNumber: string;
  latitude?: number;
  longitude?: number;
}

export const getShippingAddress = (shippingAddr: ShippingAddress): string => {
  const shippingAddrCopy = { ...shippingAddr };
  delete shippingAddrCopy.latitude;
  delete shippingAddrCopy.longitude;
  return Object.values(shippingAddrCopy)
    ?.filter((val) => typeof val === 'string' && val?.length > 0)
    ?.join(', ');
};
